import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';

export const ClientEinvoiceFields = ({ formData, setFormData }) => {
  const set = (k, v) => setFormData({ ...formData, [k]: v });
  return (
    <div data-testid="client-einvoice-fields" className="pt-3 border-t border-border space-y-3">
      <h3 className="text-xs uppercase tracking-wider font-semibold text-muted-foreground">Fatturazione elettronica</h3>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2 col-span-2">
          <Label className="label-uppercase">Codice Fiscale</Label>
          <Input data-testid="client-cf-input" value={formData.codice_fiscale || ''} maxLength={16}
            onChange={(e) => set('codice_fiscale', e.target.value.toUpperCase())} placeholder="Se diverso dalla P.IVA" className="uppercase" />
        </div>
        <div className="space-y-2">
          <Label className="label-uppercase">Provincia</Label>
          <Input data-testid="client-provincia-input" value={formData.provincia || ''} maxLength={2}
            onChange={(e) => set('provincia', e.target.value.toUpperCase().slice(0, 2))} placeholder="MI" className="uppercase" />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="label-uppercase">Codice Destinatario SDI</Label>
          <Input data-testid="client-codice-destinatario-input" value={formData.codice_destinatario || ''} maxLength={7}
            onChange={(e) => set('codice_destinatario', e.target.value.toUpperCase().replace(/\s/g, ''))} placeholder="7 caratteri" className="uppercase font-['JetBrains_Mono']" />
        </div>
        <div className="space-y-2">
          <Label className="label-uppercase">PEC</Label>
          <Input data-testid="client-pec-input" type="email" value={formData.pec || ''}
            onChange={(e) => set('pec', e.target.value)} placeholder="cliente@pec.it" />
        </div>
      </div>
      <p className="text-[10px] text-muted-foreground">Se non hai né codice né PEC la fattura arriva comunque nel cassetto fiscale del cliente.</p>
    </div>
  );
};

export default ClientEinvoiceFields;
